<style>
    .vs-card--content {
        margin-bottom: 0;
    }

    .vs-con-textarea {
        margin-bottom: 0;
    }

    .vx-input-group .vx-input-group-default:not(:last-child) input {
        border-right-color: rgba(0, 0, 0, 0) !important;
    }
</style>

<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Stock Check Details</h4>
                    </div>
                    <div class="flex items-center">
                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" icon="print" @click="reportPopup = true; count_id = 1">Report</vs-button>
                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" icon="print" @click="printPopup = true; count_id = 1">Print</vs-button>
                    </div>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Reference*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.reference" disabled/>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Check Date*
                            </div>
                            <div class="vx-col w-2/3">
                                <flat-pickr class="w-full" v-model="data.check_date" disabled/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Client ID*
                            </div>
                            <div class="vx-col w-2/3">
                                <vx-input-group>
                                    <vs-input v-model="data.client_code" disabled/>
                                    <template slot="append">
                                        <div class="append-text btn-addon">
                                            <vs-button
                                                disabled
                                                size="small"
                                                color="primary"
                                                icon-pack="feather"
                                                icon="icon-search"
                                                type="border"
                                            ></vs-button>
                                        </div>
                                    </template>
                                </vx-input-group>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Warehouse ID*
                            </div>
                            <div class="vx-col w-2/3">
                                <vx-input-group>
                                    <vs-input v-model="data.warehouses_code" disabled/>
                                    <template slot="append">
                                        <div class="append-text btn-addon">
                                            <vs-button
                                                disabled
                                                size="small"
                                                color="primary"
                                                icon-pack="feather"
                                                type="border"
                                                icon="icon-search"
                                            ></vs-button>
                                        </div>
                                    </template>
                                </vx-input-group>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-tabs class="mt-10">
                    <vs-tab label="Item Details">
                        <vs-button type="border" class="btn mr-1 mt-5" @click="params.show = true">Params</vs-button>
                        <div style="max-height: 400px; overflow: auto;" class="mt-5">
                            <vs-table :data="data.details" hoverFlat class="mt-5" stripe>
                                <template slot="thead">
                                    <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
                                    <vs-th style="min-width: 150px;">Location Type</vs-th>
                                    <vs-th style="min-width: 200px;">Location ID</vs-th>
                                    <vs-th style="min-width: 200px;">Product ID</vs-th>
                                    <vs-th style="min-width: 200px;">Description</vs-th>
                                    <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                                    <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                                    <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                                    <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                                    <vs-th style="min-width: 80px; width: 80px">Base UoM</vs-th>
                                    <vs-th style="min-width: 80px; width: 80px">Stock Type</vs-th>
                                    <vs-th style="min-width: 80px; width: 80px">Pick Qty</vs-th>
                                    <vs-th style="min-width: 80px; width: 80px">Put Qty</vs-th>
                                </template>
                                <template slot-scope="{data}">
                                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data" >
                                        <vs-td>{{ index + 1 }}</vs-td>
                                        <vs-td>{{ tr.location_type }}</vs-td>
                                        <vs-td>{{ tr.location_code }}</vs-td>
                                        <vs-td>{{ tr.product_code }}</vs-td>
                                        <vs-td>{{ tr.description }}</vs-td>
                                        <vs-td>{{ tr.pack_id }}</vs-td>
                                        <vs-td>{{ tr.batch }}</vs-td>
                                        <vs-td>{{ tr.expired_date }}</vs-td>
                                        <vs-td>{{ tr.base_qty }}</vs-td>
                                        <vs-td>{{ tr.base_uom }}</vs-td>
                                        <vs-td>{{ tr.stock_type }}</vs-td>
                                        <vs-td>{{ tr.pick_qty }}</vs-td>
                                        <vs-td>{{ tr.put_qty }}</vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                    </vs-tab>
                    <vs-tab label="Notes">
                        <vs-textarea height="200" class="mt-5" label="Notes"/>
                    </vs-tab>
                    <vs-tab label="Attachment">
                    </vs-tab>
                </vs-tabs>
            </vs-card>
        </div>

        <!-- Popup Params -->
        <vs-prompt
            title="Parameters"
            :active.sync="params.show"
            :buttons-hidden="true"
        >
            <div class="vx-row mt-6">
                <div class="vx-col w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Location Type
                        </div>
                        <div class="vx-col w-2/3">
                            <div class="vx-col full">
                                <vx-input-group>
                                    <vs-input v-model="data.location_type" disabled/>
                                    <template slot="append">
                                        <div class="append-text btn-addon">
                                            <vs-button
                                                disabled
                                                size="small"
                                                color="primary"
                                                icon-pack="feather"
                                                type="border"
                                                icon="icon-search"
                                            ></vs-button>
                                        </div>
                                    </template>
                                </vx-input-group>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Location ID
                        </div>
                        <div class="vx-col w-2/3">
                            <div class="vx-col full">
                                <vx-input-group>
                                    <vs-input v-model="data.location_code" disabled/>
                                    <template slot="append">
                                        <div class="append-text btn-addon">
                                            <vs-button
                                                disabled
                                                size="small"
                                                color="primary"
                                                icon-pack="feather"
                                                type="border"
                                                icon="icon-search"
                                            ></vs-button>
                                        </div>
                                    </template>
                                </vx-input-group>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-checkbox v-model="data.include_empty" disabled style="margin-left: -1px">Include Empty Locations</vs-checkbox>
                        </div>
                    </div> -->
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Product ID
                        </div>
                        <div class="vx-col w-2/3">
                            <div class="vx-col full">
                                <vx-input-group>
                                    <vs-input v-model="data.product_code" disabled/>
                                    <template slot="append">
                                        <div class="append-text btn-addon">
                                            <vs-button
                                                disabled
                                                size="small"
                                                color="primary"
                                                icon-pack="feather"
                                                type="border"
                                                icon="icon-search"
                                            ></vs-button>
                                        </div>
                                    </template>
                                </vx-input-group>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Pack ID
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.pack_id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Batch
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.batch" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Stock Type
                        </div>
                        <div class="vx-col w-2/3">
                            <div class="vx-col full">
                                <vx-input-group>
                                    <vs-input v-model="data.stock_type" disabled/>
                                    <template slot="append">
                                        <div class="append-text btn-addon">
                                            <vs-button
                                                disabled
                                                size="small"
                                                color="primary"
                                                icon-pack="feather"
                                                type="border"
                                                icon="icon-search"
                                            ></vs-button>
                                        </div>
                                    </template>
                                </vx-input-group>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Storage Unit
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.storage_unit" disabled/>
                        </div>
                    </div>
                </div>
            </div>
        </vs-prompt>

        <!-- Report -->
        <vs-prompt
            @accept="printReport"
            :active.sync="reportPopup"
            title="Print Report"
            >
            <div class="con-exemple-prompt">
                <div class="vx-col w-full">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <vs-select
                                class="selectExample"
                                v-model="count_id"
                                width="100%"
                            >
                                <vs-select-item value="1" text="Count 1"/>
                                <vs-select-item value="2" text="Count 2"/>
                                <vs-select-item value="3" text="Count 3"/>
                                <vs-select-item value="Result" text="Final Result"/>
                            </vs-select>
                        </div>
                    </div>
                </div>
            </div>
        </vs-prompt>

        <!-- Print -->
        <vs-prompt
            @accept="print"
            :active.sync="printPopup"
            title="Print List"
            >
            <div class="con-exemple-prompt">
                <div class="vx-col w-full">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <vs-select
                                class="selectExample"
                                v-model="count_id"
                                width="100%"
                            >
                                <vs-select-item value="1" text="Count 1"/>
                                <vs-select-item value="2" text="Count 2"/>
                                <vs-select-item value="3" text="Count 3"/>
                            </vs-select>
                        </div>
                    </div>
                </div>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
	import vSelect from 'vue-select'
	import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import { AgGridVue } from "ag-grid-vue";
    import { saveAs } from "file-saver";

	export default {
		components:{
            AgGridVue,
			vSelect,
			flatPickr,
		},
		data(){
			return {
                count_id: 1,
                reportPopup: false,
                printPopup: false,
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true
                },
                gridApi: null,
                isLoading: false,
                detailsCount: 0,
                data: {
                    reference: '',
                    check_date: new Date(),
                    warehouses_code: '',
                    client_code: '',
                    details: [],
                },
                params: {
                    show: false,
                    location_type: '',
                    location_type_id: null,
                    location_code: '',
                    location_id: null,
                    product_code: '',
                    product_id: null,
                    stock_type: '',
                    stock_type_id: null,
                    include_empty: 0,
                    pack_id: '',
                    batch: '',
                    storage_unit: ''
                },
                old_params: {},
                details: {
                    gridOptions: {},
                    gridApi: null,
                    columnDefs: [
                        {
                            headerName: "Location Type",
                            field: "location_type",
                            width: 150
                        },
                        {
                            headerName: "Location ID",
                            field: "location_code",
                            width: 150
                        },
                        {
                            headerName: "Product ID",
                            field: "product_code",
                            width: 150
                        },
                        {
                            headerName: "Description",
                            field: "description",
                            width: 150
                        },
                        {
                            headerName: "Pack ID",
                            field: "pack_id",
                            width: 150
                        },
                        {
                            headerName: "Batch",
                            field: "batch",
                            width: 150
                        },
                        {
                            headerName: "Exp. Date",
                            field: "expired_date",
                            width: 150
                        },
                        {
                            headerName: "Base Qty",
                            field: "base_qty",
                            width: 150
                        },
                        {
                            headerName: "Base UoM",
                            field: "base_uom",
                            width: 150
                        },
                        {
                            headerName: "Stock Type",
                            field: "stock_type",
                            width: 150
                        },
                        {
                            headerName: "Storage Unit",
                            field: "storage_unit",
                            width: 150
                        },
                        {
                            headerName: "Pick Qty",
                            field: "pick_qty",
                            width: 150
                        },
                        {
                            headerName: "Put Qty",
                            field: "put_qty",
                            width: 150
                        },
                    ]
                }
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            submitForm() {
                let error = false
                if(!this.data.reference) {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: "Reference is required."
                    });

                    error = true
                }

                if(!this.data.check_date) {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: "Check date is required."
                    });

                    error = true
                }

                if(this.data.details.length < 1) {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: "Detail is empty."
                    });

                    error = true
                }

                if(error) {
                    return false
                }

                const ids = this.data.details.map(item => {
                    return item.id
                })

                const data = {
                    client_code: this.data.client_code,
                    warehouses_code: this.data.warehouses_code,
                    reference: this.data.reference,
                    check_date: this.data.check_date,
                    ids: ids,
                    location_type_id: this.params.location_type_id,
                    location_id: this.params.location_id,
                    product_id: this.params.product_id,
                    stock_type_id: this.params.stock_type_id,
                    include_empty: this.params.include_empty,
                    pack_id: this.params.pack_id,
                    batch: this.params.batch,
                    storage_unit: this.params.storage_unit
                }

                this.isLoading = true
                this.$http.post('inventories/stockcheck/add', data)
                .then(res => {
                    this.isLoading = false
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: res.data.message
                    });
                })
                .catch(error => {
                    this.isLoading = false
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                    if(typeof(message) == 'string') {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            iconPack: "feather",
                            icon: "icon-x",
                            text: message
                        });
                    }
                    else {
                        message.map(msg => {
                            this.$vs.notify({
                                color: "danger",
                                title: "Error",
                                iconPack: "feather",
                                icon: "icon-x",
                                text: msg
                            });
                        })
                    }
                })
            },
            back() {
                this.$router.push({name: 'stock-check'})
            },
            fetchData() {
                this.isLoading = true
                this.$http.get('inventories/stockcheck/' + this.$route.params.id)
                .then(res => {
                    this.isLoading = false
                    this.data = res.data
                })
                .catch(error => {
                    this.isLoading = false
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Server Error',
                        text: 'Try again?',
                        accept: () => {
                            this.fetchAllData()
                        },
                        cancel: () => this.$router.push({name: 'stock-check'}),
                        acceptText: 'Yes',
                        cancelText: 'No'
                    })
                })
            },
            getData() {
                const data = {
                    client_code: this.data.client_code,
                    warehouses_code: this.data.warehouses_code,
                    location_id: this.params.location_id,
                    location_type_id: this.params.location_type_id,
                    product_id: this.params.product_id,
                    stock_type_id: this.params.stock_type_id,
                    storage_unit: this.params.storage_unit,
                    include_empty: this.params.include_empty,
                    pack_id: this.params.pack_id,
                    batch: this.params.batch,
                }

                this.data.details = []

                this.isLoading = true
                this.$http.post('inventories/stockcheck/getdetails', data)
                .then(res => {
                    this.isLoading = false
                    this.data.details = res.data
                })
                .catch(error => {
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                    this.isLoading = false;
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: message
                    });
                })
            },
            print() {
                this.isLoading = true
                this.$http.post('inventories/stockcheck/print', {id: this.$route.params.id, count_id: this.count_id}, {responseType: 'blob'})
                .then(response => {
                    this.isLoading = false
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    window.open(URL.createObjectURL(blob))
                })
                .catch(error => {
                    this.isLoading = false
                    var reader = new FileReader()
                        const globalThis = this
                        reader.onload = function() {
                            globalThis.isLoading = false
                            const object = JSON.parse(reader.result)
                            const message = object.message ? object.message : 'Something went wrong.'

                            globalThis.$vs.notify({
                                color: 'danger',
                                title: 'Error',
                                iconPack: 'feather',
                                icon:'icon-x',
                                text: message
                            })
                        }
                    reader.readAsText(error.response.data)
                })
            },
            printReport() {
                this.isLoading = true
                this.$http.post('inventories/stockcheck/printcountresult', {id: this.$route.params.id, count_id: this.count_id}, {responseType: 'blob'})
                .then(response => {
                    this.isLoading = false
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    if(this.count_id != 'Result') {
                        window.open(URL.createObjectURL(blob))
                    }
                    else {
                        saveAs(blob, `stock_check_export_${Date.now()}.xlsx`);
                    }

                })
                .catch(error => {
                    this.isLoading = false
                    var reader = new FileReader()
                        const globalThis = this
                        reader.onload = function() {
                            globalThis.isLoading = false
                            const object = JSON.parse(reader.result)
                            const message = object.message ? object.message : 'Something went wrong.'

                            globalThis.$vs.notify({
                                color: 'danger',
                                title: 'Error',
                                iconPack: 'feather',
                                icon:'icon-x',
                                text: message
                            })
                        }
                    reader.readAsText(error.response.data)
                })
            }
        },
        mounted(){
            this.fetchData()
        },
	}
</script>